import { combineActions, handleActions } from 'redux-actions';
import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';
import { pdfReportsSuccess, pdfEntityReportsSuccess, setLoading } from './actions';

export default handleActions(
  {
    [pdfReportsSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [pdfEntityReportsSuccess](state, { payload: { category, data } }) {
      return {
        ...state,
        info: {
          ...state.info,
          [category]: data,
        },
      };
    },
    [setLoading](state, { payload }) {
      return {
        ...state,
        loading: payload,
      };
    },
    [combineActions(logoutSuccess)]() {
      return initialState;
    },
  },
  initialState
);
